<template lang="pug">
.ticket-type
  .box-wrap
    .box.header-title
      ul.info
        li 購票限制
        li 開賣-截止
        li 劃位截止
        li 票價
        //- li 剩餘數量
    .box.select-box.group(v-if="ticket.active === 1 && ticket.count > 1", v-for="(ticket, index) in getTicketTypes.data", @click="typeSelect(ticket.min_group_limit, ticket.max_group_limit, index, ticket.id, dateNow < ticket.register_start_at, ticket.is_sold_out === true, ticket.description)", :class="{ selected: typeSelected.index === index, soldOutStatus: ticket.is_sold_out === true }", :disabled="dateNow < ticket.register_start_at")
      .img(v-if="typeSelected.index === index", :style="{backgroundImage: 'url(' + ticket.banner_urls.hover + ')'}")
      .img(v-else, :style="{backgroundImage: 'url(' + ticket.banner_urls.general + ')'}")
      .soldout(v-if="ticket.is_sold_out === true")
        .text SOLD OUT
      h3 {{ ticket.title }}
      ul.info
        li(v-if="ticket.min_group_limit !== ticket.max_group_limit") {{ ticket.min_group_limit }} ~ {{ ticket.max_group_limit }} 席(含)
        li(v-if="ticket.min_group_limit === ticket.max_group_limit") {{ ticket.min_group_limit }} 席
        li
          span {{ ticket.register_start_at | moment }} 
          small ({{ ticket.register_start_at | moment('Ahh:mm') }}) 
          span - {{ ticket.register_end_at | moment }}
        li
          span {{ seatEnd(ticket.seat_end_at) }}
        li ＄{{ ticket.price }}/席
        //- li {{ ticket.count }}
    //- .box.select-box.group(@click="bodilyInfo")
    .box.select-box.group.soldOutStatus
      .img(:style="{backgroundImage: 'url(' + bodily + ')'}")
      .soldout
        .text SOLD OUT
      h3 身障票
      ul.info
        li 1 ~ 2 席(含)
        li
          span 9/4 
          small (中午12:00) 
          span - 11/10
        li
          span 11/10 中午 12:00
        li $1000/2席
  hr
  .btn-wrap
    router-link.btn.ghost-btn.next-btn(:to="{name: 'ticketInfo'}", :disabled="typeSelected === 0") 下一步
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
// import { mapGetters } from 'vuex'
// import _ from 'lodash'
import bodilyUrl from 'assets/tickets-img/img-bodily.png'

export default {
  name: 'ticketType',
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.fetchTicketTypes()
      if (vm.getTicketType !== undefined) {
        vm.typeSelected = vm.getTicketType
      }
    })
  },
  props: {
  },
  data () {
    return {
      typeSelected: 0,
      dateNow: Date.now() / 1000,
      bodily: bodilyUrl
    }
  },
  computed: {
    ...mapGetters([
      'getTicketTypes',
      'getTicketType'
    ])
  },
  methods: {
    bodilyInfo () {
      this.$swal({
        title: '身障票',
        html: '<div>身障票說明：<br/>＊一次可報名 2 席，需提供身障證明方可報名，2 席座位將為隔壁，由大會安排在指定身障席。<br/><br/>欲購買身障票玩家 <br /> 請以『 <span style="color: #ff2a48; text-decoration: none; font-weight: bold;"> WirForce 2017 身障票購票申請 </span> 』 <br />作為信件標題，寄至 WirForce 票務信箱：<br />『 <a href="mailto:WirForce@4gamers.com.tw" style="color: #ff2a48; text-decoration: none; font-weight: bold;"> WirForce@4gamers.com.tw </a> 』 <br />會有專人為您處理</div>',
        confirmButtonText: '返回'
      }).then(function () {
        console.log('123')
      })
    },
    typeSelect: function (min, max, index, ticketId, isDisabled, isSoldOut, desc) {
      console.log('min:' + min, 'max:' + max, 'index:' + index, 'ticketId:' + ticketId)
      if (!isDisabled && isSoldOut === false) {
        if (min === 1 && max === 1) {
          this.typeSelected = { type: 'single', index: index, ticketId: ticketId, max: max, min: min, desc: desc }
        } else if (min > 1 || max > 1) {
          this.typeSelected = { type: 'group', index: index, ticketId: ticketId, max: max, min: min, desc: desc }
        } else {
          console.log('max:' + max, 'min' + min)
          this.typeSelected = { type: '', index: index, ticketId: ticketId, max: max, min: min, desc: desc }
        }
        this.saveTicketsType(this.typeSelected)
        console.log(this.typeSelected)
      }
    },
    seatEnd (time) {
      return moment(new Date(time)).locale('zh-tw').format('MM/DD A hh:mm')
    },
    ...mapActions([
      'saveTicketsType',
      'fetchTicketTypes'
    ])
  },
  mounted () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
@import '~stylesheets/variables'
@import '~stylesheets/mixin'
.ticket-type
  margin-top: 50px
  margin-bottom: 60px
  .box-wrap
    text-align: left
    @extend %clearfix
    .box
      // padding: 24px 32px 16px 32px
      position: relative
      padding: 24px 18px 16px 18px
      display: inline-block
      @media screen and (max-width: 640px)
        display: block
        &.header-title
          display: none
      ul
        list-style: none
        padding: 0
      &.header-title
        color: $green
        text-align: right
        ul
          li:not(:last-child)
            font-weight: bold
            padding-bottom: 3px
            border-bottom: 1px solid #888
            &:last-child
              border-bottom: none
      &.select-box
        border: 1px solid #333
        margin: 0 16px 16px 0
        text-align: center
        +transition(all, 0.3s, ease)
        @media screen and (max-width: 640px)
          margin-bottom: 30px
        ul
          li
            padding: 3px 0
            border-bottom: 1px solid #888
            @media screen and (max-width: 640px)
              padding: 12px
              &:before
                display: inline-block
                color: $green
                margin-right: 8px
              &:nth-child(1):before
                content: '購票限制'
              &:nth-child(2):before
                content: '開賣-截止'
              &:nth-child(3):before
                content: '劃位截止'
              &:nth-child(4):before
                content: '票價'
        &.soldOutStatus
          cursor: not-allowed
          border: 1px solid #333
          color: #333
          &:hover
            border: 1px solid #333
            box-shadow: none
          ul li
            border-bottom: 1px solid #333
            @media screen and (max-width: 640px)
              &:before
                color: $grey-dark
        &:hover
          border: 1px solid #888
          box-shadow: inset 0 0 10px 1px #888
        &[disabled]
          cursor: not-allowed
          border: 1px solid #333
          color: #333
          li
            border-bottom: 1px solid #333
          &:hover
            border: 1px solid #333
            box-shadow: none
        &.selected
          border: 1px solid $red
          box-shadow: inset 0 0 10px 1px $red
      .img
        width: 100px
        height: 100px
        margin: 0 auto
        background:
          position: center center
          size: contain
          repeat: no-repeat
        +transition(all, 0.3s, ease)
        @media screen and (max-width: 640px)
          margin: 0 auto
      h3
        @media screen and (max-width: 640px)
          margin-bottom: 30px
  hr
    margin-top: 64px
.soldout
  position: absolute
  top: 0
  left: 0
  background-color: rgba($red,0.2)
  width: 100%
  height: 100%
  z-index: 2
  font-size: 32px
  .text
    position: absolute
    top: 50%
    left: 50%
    opacity: 0.5
    width: 100%
    +transition(all, 0.3s, ease)
    transform: translate(-50%, -50%) rotate(-25deg)
    font-weight: bold
    color: $red
    +animation("soldout 2s infinite")
</style>



// WEBPACK FOOTER //
// ticketType.vue?ece7c726